module.exports = __webpack_public_path__ + "img/pageTitle_drug2.ec80643e.png";